import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../scss/_correspondence.scss';
// Images
import { ReactComponent as Cma } from '../images/icons/correspondent-icons/cma.svg';
import { ReactComponent as Flyer } from '../images/icons/correspondent-icons/flyer.svg';
import { ReactComponent as Percent } from '../images/icons/correspondent-icons/financialreports.svg';
import { ReactComponent as Form } from '../images/icons/correspondent-icons/form.svg';
import { ReactComponent as Graph } from '../images/icons/correspondent-icons/statsreports.svg';
import { ReactComponent as Message } from '../images/icons/correspondent-icons/messages.svg';
import { ReactComponent as Car } from '../images/icons/correspondent-icons/drivingdirections.svg';
import { ReactComponent as Searches } from '../images/icons/correspondent-icons/searches.svg';
import { ReactComponent as Favorites } from '../images/icons/correspondent-icons/favorites.svg';

import * as cooresponenceActions from '../actions/correspondence';
import { Link } from 'react-router-dom';

class Correspondence extends Component {

	componentDidMount() {
		const { cooresponenceActions } = this.props;

		// fetch all forrespondence
		cooresponenceActions.fetchCorrespondence('cma');
		cooresponenceActions.fetchCorrespondence('financialreports');
		cooresponenceActions.fetchCorrespondence('flyer');
		cooresponenceActions.fetchCorrespondence('form');
		cooresponenceActions.fetchCorrespondence('statsreports');
		cooresponenceActions.fetchCorrespondence('messages');
		cooresponenceActions.fetchCorrespondence('drivingdirections');
		// listingsfromagent and favorites have different count endpoint and link to own pages
		cooresponenceActions.fetchCorrespondenceCount('listingsfromagent');
		cooresponenceActions.fetchCorrespondenceCount('favorites');
	}

	componentDidUpdate(prevProps) {
		if (prevProps.activity.length === this.props.activity.length &&
			JSON.stringify(prevProps.activity) !== JSON.stringify(this.props.activity)) {
			// on dashboard page and activity changes they maybe changed favorites, update count
			this.props.cooresponenceActions.fetchCorrespondenceCount('favorites');
		}
	}

	render() {
		const { correspondence, isMobile } = this.props;
		if (!correspondence || Object.keys(correspondence).length === 0) return null;

		if (isMobile) 
			return <div className="grid-container">
				{(correspondence.listingsfromagent.NewCount > 0 || correspondence.listingsfromagent.TotalCount > 0) &&
					<div className="d-flex flex-column" onClick={() => this.props.history.push('/my-listings')}>
						<div className="align-items-center d-flex txt-algn-lft w-100">
							<Searches /> 
							{correspondence.listingsfromagent.NewCount > 0 &&
								<div className="dyna-new count">{correspondence.listingsfromagent.NewCount} New</div>
							}
							{correspondence.listingsfromagent.NewCount === 0 &&
								<div className="count">{correspondence.listingsfromagent.TotalCount}</div>
							}
							</div>
						<div className="txt-algn-lft mg-top-auto">Listings from My Agent</div>
					</div>
				}
				<div className="d-flex flex-column" onClick={() => this.props.history.push('/favorites-and-comments/favorites')}>
					<div className="align-items-center d-flex txt-algn-lft w-100">
						<Favorites /> 
						<div className="count">{correspondence.favorites.TotalCount}</div>
					</div>
					<div className="txt-algn-lft mg-top-auto">
						Favorites & Comments	
					</div>
				</div>
				<div className="d-flex flex-column" onClick={() => this.props.history.push('/correspondence/messages')}>
					<div className="align-items-center d-flex txt-algn-lft w-100">
						<Message /> 
						<div className="count">{correspondence.messages.totalCount}</div>
					</div>
					<div className="txt-algn-lft mg-top-auto">
						Messages
					</div>
				</div>
				{correspondence.drivingdirections.totalCount > 0 &&
					<div className="d-flex flex-column" onClick={() => this.props.history.push('/correspondence/drivingdirections')}>
						<div className="align-items-center d-flex txt-algn-lft w-100">
							<Car />
            				<div className="count">{correspondence.drivingdirections.totalCount}</div>
						</div>
						<div className="txt-algn-lft mg-top-auto">
							Driving Directions
						</div>
					</div>
				}
				{correspondence.cma.totalCount > 0 &&
					<div className="d-flex flex-column" onClick={() => this.props.history.push('/correspondence/cma')}>
						<div className="align-items-center d-flex txt-algn-lft w-100">
							<Cma /> 
							<div className="count">{correspondence.cma.totalCount}</div>
						</div>
						<div className="txt-algn-lft mg-top-auto">
							CMA
						</div>
					</div>
				}
				{correspondence.flyer.totalCount > 0 &&
					<div className="d-flex flex-column" onClick={() => this.props.history.push('/correspondence/flyer')}>
						<div className="align-items-center d-flex txt-algn-lft w-100">
							<Flyer /> 
            				<div className="count">{correspondence.flyer.totalCount}</div>
						</div>
						<div className="txt-algn-lft mg-top-auto">
							Property Flyers
						</div>
					</div>
				}
				{correspondence.financialreports.totalCount > 0 &&
					<div className="d-flex flex-column" onClick={() => this.props.history.push('/correspondence/financialreports')}>
						<div className="align-items-center d-flex txt-algn-lft w-100">
							<Percent /> 
							<div className="count">{correspondence.financialreports.totalCount}</div>
						</div>
						<div className="txt-algn-lft mg-top-auto">
							Financial Reports
						</div>
					</div>
				}
				{correspondence.form.totalCount > 0 &&
					<div className="d-flex flex-column" onClick={() => this.props.history.push('/correspondence/form')}>
						<div className="align-items-center d-flex txt-algn-lft w-100">
							<Form /> 
							<div className="count">{correspondence.form.totalCount}</div>
						</div>
						<div className="txt-algn-lft mg-top-auto">
							Real Estate Forms
						</div>
					</div>
				}
				{correspondence.statsreports.totalCount > 0 &&
					<div className="d-flex flex-column" onClick={() => this.props.history.push('/correspondence/statsreports')}>
						<div className="align-items-center d-flex txt-algn-lft w-100">
							<Graph /> 
							<div className="count">{correspondence.statsreports.totalCount}</div>
						</div>
						<div className="txt-algn-lft mg-top-auto">
							Statistics Reports
						</div>
					</div>
				}
			</div>

		return <div className="quick-links txt-algn-lft">
			<h5 className="dyna-color-555 ft-sz-14 mg-btm-12 d-lg-none">Shared Documents</h5>
			{(correspondence.listingsfromagent.NewCount > 0 || correspondence.listingsfromagent.TotalCount > 0) &&
				<Link className="quick-link pd-btm" to="/my-listings">
					<Searches /> Listings from My Agent
            		{correspondence.listingsfromagent.NewCount > 0 &&
						<div className="dyna-new count">{correspondence.listingsfromagent.NewCount} New</div>
					}
					{correspondence.listingsfromagent.NewCount === 0 &&
						<div className="count">{correspondence.listingsfromagent.TotalCount}</div>
					}
				</Link>
			}
			<Link className="quick-link pd-btm" to="/favorites-and-comments/favorites">
				<Favorites /> Favorites & Comments
				<div className="count">{correspondence.favorites.TotalCount}</div>
			</Link>
			<Link className="quick-link pd-btm" to="/correspondence/messages">
				<Message /> Messages
				<div className="count">{correspondence.messages.totalCount}</div>
			</Link>
			{correspondence.drivingdirections.totalCount > 0 &&
				<Link className="quick-link pd-btm" to="/correspondence/drivingdirections">
					<Car />
                	Driving Directions
            		<div className="count">{correspondence.drivingdirections.totalCount}</div>
				</Link>
			}
			{correspondence.cma.totalCount > 0 &&
				<Link className="quick-link pd-btm" to="/correspondence/cma">
					<Cma /> CMA
					<div className="count">{correspondence.cma.totalCount}</div>
				</Link>
			}
			{correspondence.flyer.totalCount > 0 &&
				<Link className="quick-link pd-btm" to="/correspondence/flyer">
					<Flyer /> Property Flyers
            		<div className="count">{correspondence.flyer.totalCount}</div>
				</Link>
			}
			{correspondence.financialreports.totalCount > 0 &&
				<Link className="quick-link pd-btm" to="/correspondence/financialreports">
					<Percent /> Financial Reports
            		<div className="count">{correspondence.financialreports.totalCount}</div>
				</Link>
			}
			{correspondence.form.totalCount > 0 &&
				<Link className="quick-link pd-btm" to="/correspondence/form">
					<Form /> Real Estate Forms
            		<div className="count">{correspondence.form.totalCount}</div>
				</Link>
			}
			{correspondence.statsreports.totalCount > 0 &&
				<Link className="quick-link pd-btm" to="/correspondence/statsreports">
					<Graph /> Statistics Reports
            		<div className="count">{correspondence.statsreports.totalCount}</div>
				</Link>
			}
		</div>
	}
}

const mapStateToProps = (state, props) => ({
	correspondence: { ...initialState, ...state.correspondence },
	activity: (state.activity.feed && state.activity.feed.ids) ? state.activity.feed.ids.map(id => state.entities.Activities[id]) : [],
});

const mapDispatchToProps = dispatch => ({
	cooresponenceActions: bindActionCreators(cooresponenceActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Correspondence);

export const CorrespondenceNames = {
	cma: 'CMA',
	drivingdirections: 'Driving Directions',
	financialreports: 'Financial Reports',
	flyer: 'Property Flyers',
	form: 'Real Estate Forms',
	messages: 'Messages',
	statsreports: 'Statistics Reports',
	listingsfromagent: 'Listings from My Agent',
	favorites: 'Favorites & Comments'
}

export const initialState = {
	"cma": {
		"totalCount": 0
	},
	"financialreports": {
		"totalCount": 0
	},
	"flyer": {
		"totalCount": 0
	},
	"form": {
		"totalCount": 0
	},
	"statsreports": {
		"totalCount": 0
	},
	"drivingdirections": {
		"totalCount": 0
	},
	"listingsfromagent": {
		"TotalCount": 0,
		"NewCount": 0
	},
	"favorites": {
		"TotalCount": 0
	},
	"messages": {
		"totalCount": 0
	}
}